import {observable, action, runInAction} from "mobx";
import moment from "moment";
import {SelectedLocationsStore} from "../../../services/locations/SelectedLocationsStore";

import {listPosts, rejectPost, loadPost} from "./api";

export default class ScheduledPostStore {

  @observable
  posts = [];

  @observable
  isLoading = false;

  @observable
  isLoadingPost = false;

  @observable
  isRejecting = true;

  @observable
  filterState = {
    start: moment().startOf("month").toDate(),
    end: moment().endOf("month").toDate(),
    groupId: null,
    accountId: null,
    provider: []
  };

  @action
  updateFilterState(updates = {}) {
    Object.assign(this.filterState, updates)
  }

  constructor(initialState = {}) {
    this.updateFilters(initialState);
  }

  @action
  updateFilters(newState = {}) {
    this.updateFilterState(newState)

    this.isLoading = true;
    listPosts(this.filterState).then(action("updatePosts", (postResults) => {
      this.isLoading = false;
      this.posts = postResults;
    }))
  }

  @action.bound
  rejectPost(postId, rejectionText) {
    return rejectPost(postId, rejectionText)
  }

  @action.bound
  loadPost(postId){
    this.isLoadingPost = true;
    return loadPost(postId).then(resp => {
      runInAction(() => this.isLoadingPost = false);
      return resp;
    })
  }

}
